import React from 'react';
import { Button, createStyles } from '@mantine/core';

const useButtonStlyes = createStyles(() => ({
  breakButton: {
    '*[class*="-Button-label"]': {
      textWrap: 'pretty',
    },
    height: 'auto',
    paddingTop: 5,
    paddingBottom: 5,
  },
}));

const EnsButton = React.forwardRef<HTMLButtonElement, any>(
  ({ children, breakContent = false, size = 'lg', ...props }, ref) => {
    const { classes, cx } = useButtonStlyes();

    const className = cx(
      breakContent ? classes.breakButton : undefined,
      props.className?.split(' '),
    );

    return (
      <Button size={props.size} {...props} ref={ref} className={className}>
        {children}
      </Button>
    );
  },
);

export default EnsButton;
